import { useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * Custom hook para manejar guest IDs en aplicaciones e-commerce
 * - Genera un ID único para usuarios no autenticados
 * - Limpia el ID cuando el usuario se autentica
 * - Persiste el ID entre sesiones
 *
 * @returns {string|null} guestId si existe, null si el usuario está autenticado
 */
const useGuestId = () => {
  const { userInfo } = useSelector(state => state.auth);

  useEffect(() => {
    // Si hay usuario autenticado, limpiamos cualquier guestId existente
    if (userInfo) {
      localStorage.removeItem("guestId");
      return;
    }

    // Si no hay usuario autenticado y no existe guestId, generamos uno nuevo
    if (!localStorage.getItem("guestId")) {
      const newGuestId = generateGuestId();
      localStorage.setItem("guestId", newGuestId);
    }
  }, [userInfo]);

  // Retorna el guestId actual (o null si el usuario está autenticado)
  return userInfo ? null : localStorage.getItem("guestId");
};

/**
 * Genera un ID único para usuarios invitados
 * @returns {string} ID en formato guest_timestamp_randomsuffix
 */
const generateGuestId = () => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substr(2, 9);
  return `guest_${timestamp}_${randomString}`;
};

export default useGuestId;
